import classNames from 'classnames/bind';
import styles from './EbookActivityDetails.module.css';
import { Keyword } from '../../../types/analysis';
import {
  NO_RECENT_LEARNING_PAGE,
  EXTRACTING_KEYWORD,
  PLEASE_RETRY_LATER,
  EXTRACTING_KEYWORD_ERROR,
} from '../../../constants';
import { DATA_STATUS } from '../../../constants/config';
import { isMobile } from '../../../utils/util';
import RankingList from './RankingList';

const cx = classNames.bind(styles);

interface KeywordListProps {
  keywordData?: Keyword;
}

export default function KeywordList({ keywordData }: KeywordListProps) {
  if (!keywordData) return null;

  const status = keywordData.status;

  if (status === DATA_STATUS.NO_DATA) {
    return (
      <p className={cx('keyword_status_text')}>{NO_RECENT_LEARNING_PAGE}</p>
    );
  }

  if (status === DATA_STATUS.LOADING) {
    return (
      <div className={cx('loading_indicator')}>
        <div>
          <p>{EXTRACTING_KEYWORD}</p>
          <p>{PLEASE_RETRY_LATER}</p>
        </div>
      </div>
    );
  }

  if (status === DATA_STATUS.ERROR) {
    return (
      <div className={cx('loading_indicator', 'error_state')}>
        <div>
          <p>{EXTRACTING_KEYWORD_ERROR}</p>
          <p>{PLEASE_RETRY_LATER}</p>
        </div>
      </div>
    );
  }

  if (!keywordData.keywordList) return null;

  if (isMobile) {
    const list = keywordData.keywordList;
    const rank1 = list
      .filter((item) => item.order === 1)
      .map((item) => item.keyword);
    const rank2 = list
      .filter((item) => item.order === 2)
      .map((item) => item.keyword);
    const rank3 = list
      .filter((item) => item.order === 3)
      .map((item) => item.keyword);

    return <RankingList rank1={rank1} rank2={rank2} rank3={rank3} />;
  }

  return (
    <ul className={cx('keyword_list')}>
      {keywordData.keywordList.map((item) => (
        <li key={item.order} className={cx('keyword_item')}>
          <span className={cx('keyword_item_count')}>{item.order}</span>
          <span className={cx('keyword_item_title')}>{item.keyword}</span>
        </li>
      ))}
    </ul>
  );
}
